export default __webpack_public_path__ + "static/title-f0e27bdeb00de7424a3c61dc9471fc6b.jpg";